import mqtt from 'mqtt';
import HttpTransferService from './httptransfer';
import eventEmitter from './EventEmitter';
import constant from '../constants/constant';

const httptransfer = new HttpTransferService();

class MqttClient {
  constructor() {
    this.client = null;
  }

  async connect() {
    let brokerUrl = constant.BROKER_URL
    this.client = mqtt.connect(brokerUrl);

    this.client.on('connect', () => {
      this.subscribe()
    });

    this.client.on('error', (error) => {
      console.error('MQTT error:', error);
    });
  }

  async getMqttKey() {
    let topicName;
    const mqttKey = localStorage.getItem('mqttKey');
    const expirationTime = localStorage.getItem('mqttKeyExpiration');
    if (mqttKey && expirationTime && Date.now() < parseInt(expirationTime)) {
        topicName = mqttKey;
    } else {
        try {
            const response = await httptransfer.generateMqttKey({});
            topicName = response.data.channel_key + '/' + response.data.channel_name;
            localStorage.setItem('mqttKey', topicName);
            localStorage.setItem('mqttKeyExpiration', response.data.expiry_time);
        } catch (error) {
            console.log("Error generating MQTT key:", error);
        }
    }
    return topicName;
}


async subscribe() {
  const mqttKey = await this.getMqttKey();
  this.client.subscribe(mqttKey);
  this.client.on('message', (topic, message) => {
      const jsonString = message.toString();
      let liveUpdateJson = JSON.parse(jsonString);
      console.log(`Received message on topic ${topic}: ${liveUpdateJson}`);
      // Handle incoming messages
      eventEmitter.emit('mqttMessage', liveUpdateJson);
  });
}



  connectToMqtt() {
    let topicName;
    httptransfer.generateMqttKey({})
      .then(response => {
        topicName = response.data.channel_key + '/' + response.data.channel_name;
      })
    return topicName
  }

  publish(topic, message) {
    if (this.client) {
      this.client.publish(topic, message);
    }
  }

  disconnect() {
    if (this.client) {
      this.client.end();
      console.log('Disconnected from MQTT broker');
    }
  }
}

export default MqttClient;
